var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maincontainer"},[_c('banner'),_c('pool-effect'),_c('four-intro'),_c('product-strength'),_c('time-protect'),_c('success-case'),_c('user-acknowledge'),_c('concat-us'),_c('use-immediate'),_c('about-us'),_c('melon-footer'),_c('toolBox',{on:{"openQrcodeBox":_vm.openQrcodeBox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }